module.exports = require('./lib/effects')


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-saga/effects.js
 ** module id = 730
 ** module chunks = 0
 **/